/* CHAOS Collection Hero — read-more toggle.
   Reveals the toggle button only when the description is actually
   truncated (scrollHeight beats clientHeight in clamped state).
   Short descriptions skip the toggle entirely. */
(function () {
  function init(root) {
    var dek = root.querySelector('.cf-collh__dek');
    var toggle = root.querySelector('[data-cf-collh-toggle]');
    if (!dek || !toggle) return;

    var labelEl = toggle.querySelector('.cf-collh__dek-toggle-label');
    var labelMore = labelEl ? labelEl.textContent : 'Read more';
    var labelLess = toggle.dataset.lessLabel || 'Show less';

    function checkOverflow() {
      var clamped = dek.classList.contains('cf-collh__dek--clamped');
      if (!clamped) {
        // Temporarily clamp to measure
        dek.classList.add('cf-collh__dek--clamped');
        var truncated = dek.scrollHeight - dek.clientHeight > 1;
        if (!clamped) dek.classList.remove('cf-collh__dek--clamped');
        return truncated;
      }
      return dek.scrollHeight - dek.clientHeight > 1;
    }

    if (checkOverflow()) {
      toggle.hidden = false;
    }

    toggle.addEventListener('click', function () {
      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      dek.classList.toggle('cf-collh__dek--clamped', expanded);
      if (labelEl) {
        labelEl.textContent = expanded ? labelMore : labelLess;
      }
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.cf-collh').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Re-init on theme-editor section reload
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
